// extracted by mini-css-extract-plugin
module.exports = {"slideWrapper":"v5","imageWrapper":"v6","image":"v7","copyrightAndBrandLogo":"v8","brandLogo":"v9","copyright":"v-","rentalBadge":"v_"};